export default "__VITE_ASSET__ckV0ckn3__"